var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconParkSolidBuy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_147_658",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 72,
    height: 72
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 28.125H78.75L75 78.75H15L11.25 28.125Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 35.625V11.25H60V35.625",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 63.75H60",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_147_658)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H90V90H0V0Z",
    fill: "#581343"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconParkSolidBuy);
export default __webpack_public_path__ + "static/media/icon-park-solid_buy.a11a127f40944e754435b592b4e602d3.svg";
export { ForwardRef as ReactComponent };